import React from 'react';

import { FieldArray } from '~src/settings/FormikWrapperForStubbing';

import { Alert } from '../types/Alert';
import { AlertDetailsBodyEntry } from './AlertDetailsBodyEntry';

export type AlertDetailsBodyProps = Readonly<{
    alerts: ReadonlyArray<Alert>;
}>;

export function AlertDetailsBody(props: AlertDetailsBodyProps) {
   const { alerts } = props;

  return (
    <FieldArray
        name={''}
        render={() => (
            alerts.map((alert: Alert, index) => (
            <tbody key={index}>
            <tr>
                <td>
                   <AlertDetailsBodyEntry alert={alert} />
                </td>
            </tr>
            </tbody>))
        )}
    />
  );
}
